<template>
  <div>
    <div>
    	<el-button type="primary" class="checkOrderBtn"  @click="checkOrderBtnBtn">查看订单</el-button>
    	<div class="title">业务员信息</div>
    	<div class="item-wrap">
    		<div class="item">
    		  <span class="item-title">业务员昵称：</span>
    		  <span class="item-value">{{salesman_info.user_name}}</span>
    		</div>
    		<div class="item">
    		  <span class="item-title">账号：</span>
    		  <span class="item-value">{{salesman_info.account}}</span>
    		</div>
    		<div class="item">
    		  <span class="item-title">密码：</span>
    		  <span class="item-value">{{salesman_info.plaintext_password}}</span>
    		</div>
    	</div>
    </div>
    <div class="statistics-wrap">
    	<div class="title">绩效统计</div>
    	<div class="stat-wrap">
    		<div class="stat-item">
    			<div class="stat-title">历史订单数</div>
    			<div>{{salesman_info.history_order_num}}</div>
    		</div>
    		<div class="stat-item">
    			<div class="stat-title">完成订单数</div>
    			<div>{{salesman_info.company_order_num}}</div>
    		</div>
    		<div class="stat-item">
    			<div class="stat-title">解决成功率</div>
    			<div>{{Math.round(salesman_info.solution_success_rate*100)}}%</div>
    		</div>
    	</div>
    </div>
    <div class="title">余额明细</div>
    <div class="table-wrap">
    	<el-table
		    :data="tableData"
		    border
		    style="width: 100%">
		     <el-table-column
		      prop="batch_serial_number"
		      label="流水号"
		      align="center"
        >
		    </el-table-column>
			<el-table-column
			      prop="order_code"
			      label="订单号"
			      align="center"
			>
			    </el-table-column>
		    <el-table-column
		      prop="describe"
		      label="备注"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="交易类型"
		      align="center"
        >
          <template slot-scope="scope">
          	 <span v-if="scope.row.type == 1">收入</span>
          	 <span v-if="scope.row.type == 2">支出</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      prop="now_balance"
		      label="剩余余额"
		      align="center"
        >
		    </el-table-column>
		    <el-table-column
		      label="金额"
		      align="center"
        >
          <template slot-scope="scope">
          	 <span v-if="scope.row.type == 1">+{{scope.row.amount}}</span>
          	 <span v-if="scope.row.type == 2">-{{scope.row.amount}}</span>
          </template>
		    </el-table-column>
		    <el-table-column
		      prop="create_time"
		      label="时间"
		      align="center"
        >
		    </el-table-column>
		  </el-table>
		  <common-pagination
		  :total="total"
      :page_size="page_size"
		   @size-change="handelPagesizeChange"
		   @page-change="handlePageChange"
		  ></common-pagination>
    </div>
  </div>
</template>

<script>
import CommonPagination from '@/components/CommonPagination';
import { salesmanDetail } from '@/api/business-manage';
import { userBalanceRecord } from '@/api/user'

export default {
  name: 'salesmandetail',
  data() {
  	return {
      tableData: [],
      page_index: '1',  //第几页
  		page_size: '10',
  		total: 0, //总条数
  		uuid: '',
  		salesman_info: {}
  	}
  },
  components: {
    CommonPagination,
  },
  mounted() {
  	let uuid = this.$route.query.uuid;
  	this.uuid = uuid;
  	this.getSalesmanDetail(uuid);
  	this.getSalesmanBalanceRecord();
  },
  methods: {
  	async getSalesmanDetail(uuid) {
       const { data, status } = await salesmanDetail(uuid);
       if (status !== 200) return
      //  data.solution_success_rate = data.solution_success_rate.;
       console.log(data, 'detail')
       this.salesman_info = data;
  	},
  	async getSalesmanBalanceRecord() {
      let postData = {
     	  page_index: this.page_index,
     	  page_size: this.page_size,
      };
      const { data, status } = await userBalanceRecord(this.uuid, postData);
      if (status !==200) return
      this.tableData = data.data;
      this.total = data.total;
  	},
  	handelPagesizeChange(size) {
      this.page_size = size;
      this.getSalesmanBalanceRecord();
  	},
  	handlePageChange(page) {
      this.page_index = page;
      this.getSalesmanBalanceRecord();
  	},
    checkOrderBtnBtn() {
      this.$router.push({
        path: '/order-list',
        query: {
          uuid: this.uuid
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
	margin-bottom: 30px;
	font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(76,76,76,1);
  line-height: 28px
}
.item-wrap {
  display: flex;
	.item {
		.item-title {
			margin-right: 30px;
			font-size: 16px;
	    font-family: PingFangSC-Regular;
	    font-weight: 400;
	    color: rgba(153,153,153,1);
		}
		.item-value {
			margin-right: 80px;
		}
	}
}
.checkOrderBtn {
	float: right;
}
.statistics-wrap {
	margin-top: 40px;
	margin-bottom: 40px;
	.stat-wrap {
		display: flex;
		justify-content: center;
		.stat-item {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 150px;
			height: 150px;
			margin-right: 30px;
			border: 1px solid #000;
			.stat-title {
				margin-bottom: 30px;
			}
		}
	}
}
</style>
